import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import './LanguageDropdownItem.scss';

import { useApp } from '../../../providers/App';
import { redirectByDomain } from '../../../utils';

const LanguageDropdownItem = ({ flag, label, action, setIsOpen }) => {
  const { setSiteLang } = useApp();
  const itemRef = useRef(null);

  useEffect(() => {
    const handleClick = () => {
      const pageId = window.__PAGE_ID__ || 'home';

      const targetDomain =
        action === 'pt-BR'
          ? 'com.br'
          : 'us';

      redirectByDomain({
        pageId,
        targetDomain,
      });

      setSiteLang(action);
      setIsOpen(false);
    };

    const el = itemRef.current;
    el.addEventListener('click', handleClick);

    return () => {
      el.removeEventListener('click', handleClick);
    };
  }, [action, setIsOpen, setSiteLang]);

  return (
    <div ref={itemRef} className="dropdown-item">
      <img
        className="dropdown-item-flag"
        src={flag}
        width={32}
        height={32}
        alt={label}
      />
      <div className="dropdown-item-label">{label}</div>
    </div>
  );
};

LanguageDropdownItem.propTypes = {
  flag: PropTypes.string,
  label: PropTypes.string.isRequired,
  action: PropTypes.string.isRequired,
  setIsOpen: PropTypes.func.isRequired,
};

export default LanguageDropdownItem;